import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=7a4cd44c&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a4cd44c')) {
      api.createRecord('7a4cd44c', component.options)
    } else {
      api.reload('7a4cd44c', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=7a4cd44c&", function () {
      api.rerender('7a4cd44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QGonrs8xtRA5/JS/cancellationPolicy.vue"
export default component.exports